export default __webpack_public_path__ + "static/media/ferman_1.745d832d.png";